import { SvgIcon } from '@mui/material';
import { Component } from 'react';

export default class SpeechToTextIcon extends Component {
    render() {
        return (
            <SvgIcon
                {...this.props}
                viewBox="0 -960 960 960"
            >
                <path d="M689.57-570q-28.57 0-49.07-20.5T620-640v-160q0-29 20.56-49.5Q661.13-870 690-870q29 0 49.5 20.5T760-800v160q0 29-20.5 49.5T689.57-570ZM180-80q-24.75 0-42.37-17.63Q120-115.25 120-140v-680q0-24.75 17.63-42.38Q155.25-880 180-880h340v60H180v680h480v-110h60v110q0 24.75-17.62 42.37Q684.75-80 660-80H180Zm100-170v-60h280v60H280Zm0-120v-60h200v60H280Zm440 40h-60v-102q-76-11-128-70t-52-138h60q0 62 43.88 106 43.89 44 105.97 44 63.15 0 106.65-43.93Q840-577.86 840-640h60q0 79-51.5 138T720-432v102Z" />
            </SvgIcon>
        );
    }
}
